import { createWebHistory, createRouter } from "vue-router";
import conf from '/src/config';



const router = createRouter({
    history: createWebHistory(conf.appBaseUrl),
    duplicateNavigationPolicy: 'reload',
    routes :[
        {
            path: "/",
            name:'HomePage',
            component: () => import('../views/HomePage')
        },
        {
            path: "/schoolLists",
            name:'SchoolLists',
            component: () => import('../views/SchoolLists')
        },
        {
            path: "/shoppingCart",
            name:'ShoppingCart',
            component: () => import('../views/ShoppingCart')
        },
        {
            path: "/checkout",
            name:'Checkout',
            component: () => import('../views/Checkout')
        },
        {
            path: "/checkout",
            name:'Checkout',
            component: () => import('../views/Checkout')
        },
        {
            path: "/reCheckout",
            name:'ReCheckout',
            component: () => import('../views/ReCheckout')
        },
        {
            path: "/success",
            name:'Success',
            component: () => import('../views/Success')
        },
        {
            path: "/orderSearch",
            name:'OrderSearch',
            component: () => import('../views/OrderSearch')
        },
        {
            path: '/page/:link',
            name: 'Page',
            component: () => import('../views/Page'),
        },
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ],
});

export default router;
